<template>
    <div class="">
        <div class="row no-gutters py-2 mb-3">
            <div class="col-md-9 col-sm-12">
                <h4 class="atlhr-dashboard-title mt-10">
                    Monthly Contribution Run <span class="black-title"></span>
                </h4>
            </div>
        </div>

        <div class="col-sm-12 float-right text-right my-3" v-if="this.companyGfSettings.data.gf_enabled.opt_value == 'true'">
            <b-button id="show-btn" class="" @click="monthlyGfContribution()">New Monthly Contribution</b-button>
            <b-button id="show-btn" class="" @click="oneoffGfContribution()">New One-Off Contribution</b-button>
            <!-- <b-button id="show-btn" class="" @click="monthlyGfView()">Monthly Contribution View</b-button>             -->
        </div>
        <div class=" col-md-12 border-0 ibox  mx-0 p-3 mt-3">
            <gf-run-list :pageurl="$api_url" v-on:childToParent="listReturn"  :status='draft_flag' st="draft" title="Draft Contribution Runs" :key="draft_key"></gf-run-list>
            <gf-run-list :pageurl="$api_url" v-on:childToParent="listReturn"  :status='approved_flag' st="approved" title="Approved Contribution Runs" :key="approved_key"></gf-run-list>
        </div>

        <b-modal id="bv-modal-monthly-gf-contribution" size="lg" hide-footer :title="gf_type === 'monthly' ? 'Monthly Gratuity Fund Contribution' : 'One-Off Gratuity Fund Contribution'">
            <!-- Start: Rejwan: 24-05-2025 Gf run -->
            <gf-run-form :gf_type="gf_type" :key="gf_run_form" @listReturn="listReturn"></gf-run-form>
            <!-- End: Rejwan: 24-05-2025 Gf run -->
        </b-modal>

    </div>
</template>


<script>

    export default{

        mounted() {

        },
        props: ['pageurl'],

        data(){

            return {

                month : null,
                months :null,
                year : null,
                draft_flag:null,
                approved_flag:null,
                draft_key:0,
                approved_key:0,
                gf_type: '',
                type_of_run: '',
                data: {},
                gf_run_form: 0, // Rejwan: 24-05-2025 Gf Run
                companyGfSettings: null// Sifat: 02-07-2025 GF disabled hiding error
            }
        },
        methods:{
            getDashboardData()
            {
                this.draft_flag = 0;
                this.approved_flag =1;
                this.draft_key +=1;
                this.approved_key +=1;
            },
            listReturn:function(data)
            {
                this.draft_key += 1;
                this.approved_key += 1;

                // Start: Rejwan: 24-05-2025 Gf Run
                // if(data == 'run_form') {
                //     }
                    this.$bvModal.hide('bv-modal-monthly-gf-contribution');
                // End: Rejwan: 24-05-2025 Gf Run
                if(data && data.success) {
                    this.$bvToast.toast(data.message, {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                }
            },
            monthlyGfContribution(){
                this.gf_type='monthly';
                console.log(123);
                this.gf_run_form += 1; // Rejwan: 24-05-2025 Gf Run
                this.$bvModal.show('bv-modal-monthly-gf-contribution');
            },
            oneoffGfContribution(){
                // this.$bvModal.show('bv-modal-oneoff-gf-contribution');
                this.gf_type='oneoff';
                this.gf_run_form += 1; // Rejwan: 24-05-2025 Gf Run
                this.$bvModal.show('bv-modal-monthly-gf-contribution');
            },
            //Start:- Sifat: 02-07-2025 GF disabled hiding error
            getCompanyGfSettings() {
                axios.get(this.$api_url + '/gf/companygfsettings')
                    .then(response => {
                        this.companyGfSettings = response.data;
                    })
                    .catch(error => {
                        console.error("Error fetching company GF settings:", error);
                    });
            },
            //End:- Sifat: 02-07-2025 GF disabled hiding error

        },
        created: function(){
            this.getDashboardData();
            this.getCompanyGfSettings();
        },

    }
</script>
